import makeCreator from '@main/factories/pages/makeCreator';
import { useData } from 'vike-react/useData';

import type { Data } from './+data';

export function Page() {
	const { creator, firstPage, intro } = useData<Data>();

	return makeCreator(creator, firstPage, intro);
}
